module.exports = __webpack_public_path__ + "img/202.36b9d992.jpg";